export const CART_ITEMS_DATA_QUERY_KEY = 'shopping-cart-items';
